import moment from 'moment'

export const $_validate_rules = {
  data () {
    return {
      rules: {
        required: value => !!value || 'Обязательно к заполнению.',
        requiredcombo: value => (!!value && value.length>0) || 'Обязательно к заполнению.',
        number: value => {
          const pattern = /^[0-9]+$/
          return pattern.test(value) || 'Допустимы только цифры.'
        },
        text: value => {
          const pattern = /^[A-Za-zа-яА-ЯёЁ0-9.-]+/
          return pattern.test(value) || 'Допустимы только цифры, буквы, "." или "-"'
        },
        rudate: value => {
          return moment(value, 'DD.MM.YYYY', true).isValid()  || 'Не верный формат даты.'
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Некорректный e-mail.'
        },
        emailcombo: value => {
          if (!value || !value.length) {
            return true
          }
          
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          let res = true

          for (let index = 0; index < value.length; index++) {
            const element = value[index];
            const data = element instanceof Object ? element.data : element
            res = res && pattern.test(data)
          }
          return res || 'Некорректный e-mail.'
        },
        inn: value => {
          return validateINN(value) || 'Указан неверный ИНН'
        },
        bankBIK: value => {
          return value.length == 9 || 'Указан неверный БИК банка'
        },
        payerBill: value => {
          return value.length == 20 || 'Указан неверный расчетный счет плательщика'
        }
      }, 
    }
  }
}

export function validateINN(number) {
  // Проверка длины
  if (!/^[0-9]{10}$|^[0-9]{12}$/.test(number)) {
    return false
  }

  // Проверка контрольных цифр
  const n = number.split('').map(Number)

  if (number.length === 10) {
    const controlCode = Number(number[9])
    const checkCode =
      ((2 * n[0] +
        4 * n[1] +
        10 * n[2] +
        3 * n[3] +
        5 * n[4] +
        9 * n[5] +
        4 * n[6] +
        6 * n[7] +
        8 * n[8]) %
        11) %
      10

    return checkCode === controlCode
  } else {
    const controlCode1 = Number(number[10])
    const controlCode2 = Number(number[11])

    const checkCode1 =
      ((7 * n[0] +
        2 * n[1] +
        4 * n[2] +
        10 * n[3] +
        3 * n[4] +
        5 * n[5] +
        9 * n[6] +
        4 * n[7] +
        6 * n[8] +
        8 * n[9]) %
        11) %
      10
    const checkCode2 =
      ((3 * n[0] +
        7 * n[1] +
        2 * n[2] +
        4 * n[3] +
        10 * n[4] +
        3 * n[5] +
        5 * n[6] +
        9 * n[7] +
        4 * n[8] +
        6 * n[9] +
        8 * checkCode1) %
        11) %
      10

    return checkCode1 === controlCode1 && checkCode2 === controlCode2
  }
}

